// extracted by mini-css-extract-plugin
module.exports = {"vk7l9fj":"vk7l9fj","aojyyon":"aojyyon","cvpd70m":"cvpd70m"};